// src/components/VerifyEmail.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from '../services/axios';

const VerifyEmail = () => {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

// VerifyEmail.jsx - FIXED handleSubmit section

useEffect(() => {
  const verifyEmail = async () => {
    if (!token) {
      setStatus('error');
      setMessage('Token verifikasi tidak valid');
      return;
    }

    try {
      console.log('🔵 Verifying email with token:', token);
      
      // ❌ SALAH: '/api/auth/verify-email'
      // ✅ BENAR: '/auth/verify-email'
      const res = await axios.post('/auth/verify-email', { token });  // ✅ FIXED
      
      console.log('🟢 Email verification success:', res.data);
      setStatus('success');
      setMessage(res.data.message);
      setUserData(res.data.user);
      
      // Simpan token dan user data
      if (res.data.token && res.data.user) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
      }
      
      // Redirect ke dashboard setelah 3 detik
      setTimeout(() => {
        navigate('/dashboard', { replace: true });
      }, 3000);
      
    } catch (err) {
      console.error('❌ Email verification failed:', err.response?.data || err.message);
      const msg = err.response?.data?.message || 'Verifikasi email gagal';
      setStatus('error');
      setMessage(msg);
    }
  };

  verifyEmail();
}, [token, navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Verifikasi Email</h2>
        
        {status === 'loading' && (
          <div style={styles.loading}>
            <p>Memverifikasi email...</p>
          </div>
        )}
        
        {status === 'success' && (
          <div style={styles.success}>
            <div style={styles.successIcon}>✅</div>
            <h3>Verifikasi Berhasil!</h3>
            <p>{message}</p>
            {userData && (
              <p>Halo <strong>{userData.name}</strong>, Anda akan diarahkan ke dashboard...</p>
            )}
            <div style={styles.spinner}></div>
          </div>
        )}
        
        {status === 'error' && (
          <div style={styles.error}>
            <div style={styles.errorIcon}>❌</div>
            <h3>Verifikasi Gagal</h3>
            <p>{message}</p>
            <div style={styles.actions}>
              <Link to="/login" style={styles.primaryButton}>
                Kembali ke Login
              </Link>
              <Link to="/register" style={styles.secondaryButton}>
                Daftar Ulang
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1a3c6d, #4a90e2)',
    fontFamily: '"Segoe UI", sans-serif',
  },
  card: {
    width: 450,
    padding: '40px 30px',
    background: 'white',
    borderRadius: 16,
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
    textAlign: 'center',
  },
  title: {
    margin: 0,
    marginBottom: 20,
    fontSize: 28,
    color: '#1a3c6d',
    fontWeight: 'bold',
  },
  loading: {
    color: '#1a3c6d',
    fontSize: 16,
  },
  success: {
    color: '#27ae60',
    fontSize: 16,
  },
  successIcon: {
    fontSize: '48px',
    marginBottom: '15px',
  },
  error: {
    color: '#e74c3c',
    fontSize: 16,
  },
  errorIcon: {
    fontSize: '48px',
    marginBottom: '15px',
  },
  spinner: {
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #3498db',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    animation: 'spin 2s linear infinite',
    margin: '20px auto',
  },
  actions: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  primaryButton: {
    padding: '12px 20px',
    background: '#1a3c6d',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: 'bold',
  },
  secondaryButton: {
    padding: '12px 20px',
    background: '#4a90e2',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: 'bold',
  },
};

// Tambahkan CSS animation
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(`
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`, styleSheet.cssRules.length);

export default VerifyEmail;
